import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { loanService } from "../../../../api/services/loanService";
import { setAllActiveLoans } from "../../../../infra/aggregates/myProfile/loansAggregates/activeLoansSlice";
import { offBoardingService } from "../../../../api/services/offBoardingService";

interface PropsValues {
  setReasonsForResignations: (data: any) => void;
}

function DTOWithdrawModal({ setReasonsForResignations }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);

  async function getReasons(empId: number) {
    const response = await offBoardingService.getReasonsForResignation(empId);
    if (response.response == "success") {
      setReasonsForResignations(response?.data);
    } else {
      return;
    }
  }

  useEffect(() => {
    if (selector.company_id) getReasons(selector.company_id);
  }, []);

  return <></>;
}
export default DTOWithdrawModal;
